import { render } from "./art-direction.vue?vue&type=template&id=f3aafdc0"
import script from "./art-direction.vue?vue&type=script&lang=js"
export * from "./art-direction.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ian/codebase/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__